<div class="company-cards-container d-flex flex-wrap gap-2">
  <mat-card class="company-card" [ngClass]="{'loading': isLoading}" *ngFor="let company of companyCards" (click)="goToCompany(company.id)">
    <mat-card-content class="card-content">
      <div class="logo-container">
        <ng-container *ngIf="isLoading; else companyLogo">
          <div class="skeleton-logo"></div>
        </ng-container>
        <ng-template #companyLogo>
          <img [src]="company.logoUrl"
               alt="{{company.companyName}} logo"
               class="company-logo"
               (error)="company.logoUrl = 'assets/images/no-logo.png'">
        </ng-template>
      </div>
      <div class="text-content">
        <ng-container *ngIf="isLoading; else companyContent">
          <div class="skeleton-title"></div>
          <div class="skeleton-description"></div>
        </ng-container>
        <ng-template #companyContent>
          <mat-card-title class="company-title text-truncate">{{company.companyName}}</mat-card-title>
          <p class="company-description text-truncate">{{company.description}}</p>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</div>